import React from "react";
import TitleComponent from "../components/common/TitleComponent";
import { FaLeaf, FaHeartbeat, FaHandsHelping } from "react-icons/fa";
import { motion } from "framer-motion";
import BreadcrumbsComponent from "../components/common/BreadcrumbsComponent";

import aboutUs_banner from '../assets/images/bannerImage/about_us.webp'

const BreadCrumbsPath = [
  {
    id: 1,
    pathName: "About Us",
    pathLink: "/about-us",
  },
];
const AboutUs: React.FC = () => {
  return (
    <>
    <div className="mt-20 xl:mt-0 hidden md:block">
            <div className="flex mb-2 items-center justify-center">
              <img
                src={aboutUs_banner}
                alt="Ceylon Hospital Banner"
                width={1200}
                height={630}
                loading="eager"
                className="w-full  max-w-8xl"
                decoding="async"
                style={{
                  height: "auto",
                  objectFit: "cover",
                }}
              />
            </div>
          </div>
      <BreadcrumbsComponent breadCrumbsPath={BreadCrumbsPath} />
      <div className=" px-2 mb-6">
        <div className="">
          <TitleComponent
            Title={"Where Ayurveda Meets Modern Care"}
            Subtitle={""}
          />

          <p className="text-gray-800 text-lg text-center mb-10 mt-3  Blinker-Regular">
            Embracing the wisdom of Ayurveda to promote holistic well-being.
          </p>

          <p className="text-lg leading-snug text-justify lg:px-20 px-3 mb-10  Blinker-Light">
            At Ceylon Hospital, we blend the timeless healing practices of
            Ayurveda with advanced modern care to provide holistic wellness
            solutions. Our dedicated team combines natural remedies with
            evidence-based treatments, ensuring personalized care for every
            patient.
          </p>

          {/* Our Values */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:px-10 px-2">
            <div className="bg-green-100 p-5 text-center rounded-2xl ">
              <FaLeaf className="text-green-500 text-5xl mx-auto mb-3" />
              <h3 className="text-xl font-semibold mb-2  Blinker-SemiBold">
                Natural Healing
              </h3>
              <p className=" Blinker-Regular leading-snug">
                We harness the power of herbs, oils, and Ayurvedic techniques
                for natural rejuvenation.
              </p>
            </div>

            <div className="bg-green-100 p-5 text-center rounded-2xl">
              <FaHeartbeat className="text-green-500 text-5xl mx-auto mb-3" />
              <h3 className="text-xl font-semibold mb-2  Blinker-SemiBold">
                Personalized Care
              </h3>
              <p className=" Blinker-Regular leading-snug">
                Our treatments are tailored to your unique body type and health
                conditions.
              </p>
            </div>

            <div className="bg-green-100 p-5 text-center rounded-2xl">
              <FaHandsHelping className="text-green-500 text-5xl mx-auto mb-3" />
              <h3 className="text-xl font-semibold mb-2  Blinker-SemiBold">
                Compassionate Support
              </h3>
              <p className=" Blinker-Regular leading-snug">
                Our team ensures you feel supported, cared for, and valued
                throughout your journey.
              </p>
            </div>
          </div>

          {/* Call to Action */}
          <div className="lg:px-10 px-2">
            <motion.div
              className="bg-green-500 text-white text-center p-6 rounded-lg shadow-lg mt-10"
              whileHover={{ scale: 1.05 }}
            >
              <h2 className="text-4xl mb-2  Blinker-SemiBold">
                Begin Your Ayurvedic Wellness Journey
              </h2>
              <p className="mb-4  Blinker-Light text-lg leading-tight">
                Experience the power of Ayurveda with personalized treatments at
                Ceylon Hospital.
              </p>
              <a
                href="https://wa.me/94705509898"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button className="bg-white text-green-500 px-6 py-2 rounded-full font-semibold hover:bg-green-600 hover:text-white transition  Blinker-SemiBold text-lg">
                  Contact Us Today
                </button>
              </a>
            </motion.div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutUs;
